




import { Component, Vue } from "vue-property-decorator";

import UpgradeAllocationWorkspace from "./Workspace.vue";

@Component({ components: { UpgradeAllocationWorkspace } })
export default class UpgradeAllocationEditForm extends Vue {}
